import { Reveal } from "@/components/Reveal";
import { PhoneCTA, WhatsAppCTA } from "@/components/ContactButtons";
import { EMAIL, EMAIL_MAILTO } from "@/lib/contact";
import { track } from "@/lib/track";

const ContactBlock = ({ withId = false }) => (
  <section
    id={withId ? "contact" : undefined}
    data-testid="contact-section"
    className="relative overflow-hidden bg-[#0d2731] py-20 sm:py-24 lg:py-28 scroll-mt-24"
  >
    <div className="absolute inset-0 dotted-bg-light opacity-50" aria-hidden="true" />
    <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full border border-[#b5c4b1]/15" aria-hidden="true" />
    <div className="absolute -bottom-32 -left-20 h-96 w-96 rounded-full border border-[#b5c4b1]/10" aria-hidden="true" />
    <div className="container-avelis relative text-center">
      <Reveal>
        <span className="dot-sage !h-2.5 !w-2.5 mx-auto" aria-hidden="true" />
        <h2 className="mt-6 mx-auto max-w-2xl text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.12] text-[#f6f3ec]">
          Parlons de votre facturation.
        </h2>
        <p className="mt-6 mx-auto max-w-xl text-base sm:text-lg text-[#f6f3ec]/70 leading-relaxed">
          Une question sur votre organisation, le tarif ou la prise en charge de votre facturation ? Contactez directement AVELIS par téléphone ou par WhatsApp.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row justify-center gap-3.5">
          <PhoneCTA location="contact" className="!bg-[#f6f3ec] !text-[#0d2731] hover:!bg-[#b5c4b1]" />
          <WhatsAppCTA location="contact" />
        </div>
        <p className="mt-7 text-sm text-[#f6f3ec]/70">
          Vous préférez nous écrire ?{" "}
          <a
            href={EMAIL_MAILTO}
            data-testid="cta-email-contact"
            onClick={() => track("click_email")}
            className="font-bold text-[#b5c4b1] underline underline-offset-4 decoration-[#b5c4b1]/40 hover:decoration-[#b5c4b1] transition-[text-decoration-color] duration-200"
          >
            {EMAIL}
          </a>
        </p>
        <p className="mt-4 text-xs font-semibold tracking-wide text-[#f6f3ec]/55">
          Premier échange gratuit • Sans engagement
        </p>
      </Reveal>
    </div>
  </section>
);

export default ContactBlock;
